import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { bindActionCreators } from "redux";
import { useMemo } from "react";
import { FlexRateModal } from "app/pages/Booking/Quotation/FlexRate/FlexRateModal";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";
import { showFlexRatesModal } from "app/pages/Booking/Quotation/quotationActionCreators";
import { calculateQuoteBaseAndExtrasTotal } from "app/pages/Booking/bookingSelectors";

const mapStateToProps = state => {
	const booking = state.booking;

	return {
		total: calculateQuoteBaseAndExtrasTotal(state),
		vendor: state.vendor,
		nbPassengers: booking.passengers ? booking.passengers.length : 0,
		quotation: state.quotation,
		isOpened: state.quotation.isFlexRatesModalOpened,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ updateBooking, showFlexRatesModal }, dispatch);
};

const FlexRateModalContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	return <FlexRateModal {...props} {...stateProps} {...dispatchProps} />;
};

export default FlexRateModalContainer;
